
import React from 'react'
import icon from './svgs/CupStar.svg'
import { BaseIcon } from './_base'

export const CupsStarIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
